import React from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import Fade from 'react-reveal/Fade';
import { Link, useParams } from 'react-router-dom';
import useFetch from '../hooks/useFetch';

const ServicesDetailScreen = () => {
  const { title } = useParams();
  const [data] = useFetch('services');

  return (
    <section className="max-w-screen-xl mx-auto px-6 py-24 bg-gray-50 min-h-screen flex items-center justify-center">
      {data
        .filter(item => item.title === title)
        .map(service => (
          <div key={service.id} className="bg-white shadow-2xl rounded-2xl overflow-hidden max-w-4xl w-full p-8">
            <Fade top>
              {/* Banner Image */}
              <img
                className="w-full h-72 object-cover rounded-xl mb-8"
                src={service.image}
                alt={service.title}
              />
            </Fade>
            <Fade bottom cascade>
              {/* Icon + Title */}
              <div className="flex flex-col md:flex-row items-center md:space-x-6 text-center md:text-left mb-8">
                <img
                  className="w-24 h-24 rounded-full object-cover shadow-lg mb-4 md:mb-0"
                  src={service.icon}
                  alt={service.title}
                />
                <h1 className="text-gray-800 font-bold text-3xl md:text-4xl poppins">{service.title}</h1>
              </div>
              {/* Full Description */}
              <p className="text-gray-600 leading-relaxed text-lg mb-10 text-justify">
                {service.fullDescription || service.description}
              </p>
            </Fade>
            {/* Back Button */}
            <div className="flex justify-center">
              <Link
                to="/"
                className="inline-flex items-center space-x-2 px-6 py-3 border border-paragaia text-paragaia rounded-full text-sm font-semibold hover:bg-paragaia hover:text-white transition ease-in-out duration-300"
              >
                <BsArrowLeft className="text-lg" />
                <span>Retour aux services</span>
              </Link>
            </div>
          </div>
        ))}
    </section>
  );
};

export default ServicesDetailScreen;
